import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AdminSessionContainer from './SessionList';
import {Link} from 'react-router-dom';
import * as firebase from 'firebase';
let includelocks = false;
//gets user props from app.js

let that;
let secretphrase = "locked";
/**
 * This component is the admin homepage and renders the admin session
 * simulationContainer as well as quick start, custom session, and manage admin buttons
 */
class AdminHome extends Component {
    constructor(props) {
        super(props);
        that = this;
        this.state = {
            isWaiting: false,
            waitingForId: '',
            stepsEnabled: false,
            initialStep: 0,
            locked: includelocks,
            steps: [
                {
                    intro: "Welcome to the Green Impact Exchange!"
                },
                {
                    element: '.join',
                    intro: 'You can join your session here! Join now!'
                },
            ]
        };
        this.networkSession = this.networkSession.bind(this);
        this.soloSession = this.soloSession.bind(this)
        this.demoSession = this.demoSession.bind(this)

    }

    sessionArrived() {
      this.setState({
        isWaiting: false,
        waitingForId: ''
      });
    }

    toggleLock() {
      if (includelocks){
        let response = prompt("locked code?");
        //alert(response);
        if (response == secretphrase){
          that.lockRef.set(!that.state.locked);
        }
      }
    }

    //this function generates a quick session with default parameters
    networkSession() {
        console.log("AdminHome networkSession");
        let proceed = true;
        if (!!that.state.locked){
          let response = prompt("locked code?");
          //alert(response);
          if (response == secretphrase){
            proceed = true;
          } else {
            proceed = false;
          }
        }
        if (!proceed){
          return;
        }
        //TODO: change these for a network session
        //Select one DB at random here...
        //let db_index = 2;//[0,1,3][Math.floor(Math.random()*3)];
        let db_index = [0,1,2,3][Math.floor(Math.random()*4)];

        const sessionRef = this.props.dbs[db_index].database().ref().child(this.props.institution).child("Sessions");
        const newSessionRef = sessionRef.push();
        const timeCreated = new Date().toString();
        const timestamp = new Date().getTime();
        let isSlow = confirm("Would you like this to be a slow session?");
        let msPerSec = 25;
        if (!!isSlow){
          msPerSec = 50;
        }
        const session = {
            //"Title": this.props.user.displayName + timeCreated,
            "UserCount": 0,
            "GameParams": {
                "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
                "msPerSec": msPerSec,
                "numLiq": 150,
                "numInf": 150,
                "numMom": 75,
                "numPStar": 3,
                "FracOfDay": 1
            },
            "StartSim": {
                "SessionID": newSessionRef.key
            },
            "Info": {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false,
                "Demo": false,
                "AuctionMode": 0,
                "Timestamp": timestamp
            }
        };
        newSessionRef.set(session).then(()=>{
          this.setState({
            isWaiting: true,
            waitingForId: newSessionRef.key
          });
          let that = this;
          console.log("waiting for", newSessionRef.key);
          const waitingFor = this.props.dbs[db_index].database().ref().child(this.props.institution).child("PlayableSessions").child(newSessionRef.key);
          waitingFor.on('value', (ss)=>{
            console.log("got value change");
            let data = ss.val();
            if (!data){
              return null;
            } else {
              that.sessionArrived();
              waitingFor.off();
            }
          });
        });
        /*newSessionRef.child("Info").set(
            {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false
            })*/
        // console.log("called");
        // let adminRef = this.props.dbs[0].database().ref().child("Admin");
        // let newadminRef = adminRef.push();
        // console.log(newadminRef);
        // let admin = {
        //   "name": "jorss"
        // };
        // console.log(admin);
        // newadminRef.set(admin);
    }

    soloSession() {
        console.log("AdminHome soloSession");
        let proceed = true;
        if (!!that.state.locked){
          let response = prompt("locked code?");
          //alert(response);
          if (response == secretphrase){
            proceed = true;
          } else {
            proceed = false;
          }
        }
        if (!proceed){
          return;
        }
        //Select one DB at random here...
        //let db_index = 2;//[0,1,3][Math.floor(Math.random()*3)];
        let db_index = [0,1,2,3][Math.floor(Math.random()*4)];
        const sessionRef = this.props.dbs[db_index].database().ref().child(this.props.institution).child("Sessions");
        const newSessionRef = sessionRef.push();
        const timeCreated = new Date().toString();
        const timestamp = new Date().getTime();
        let isSlow = confirm("Would you like this to be a slow session?");
        let msPerSec = 25;
        if (!!isSlow){
          msPerSec = 50;
        }
        const session = {
            //"Title": this.props.user.displayName + timeCreated,
            "UserCount": 15,
            "GameParams": {
                "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
                "msPerSec": msPerSec,
                "numLiq": 300,
                "numInf": 150,
                "numMom": 75,
                "numPStar": 3,
                "FracOfDay": 1
            },
            "StartSim": {
                "SessionID": newSessionRef.key
            },
            "Info": {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": true,
                "Demo": false,
                "AuctionMode": 0,
                "Timestamp": timestamp
            }
        };
        newSessionRef.set(session).then(()=>{
          this.setState({
            isWaiting: true,
            waitingForId: newSessionRef.key
          });
          let that = this;
          console.log("waiting for", newSessionRef.key);
          const waitingFor = this.props.dbs[db_index].database().ref().child(this.props.institution).child("PlayableSessions").child(newSessionRef.key);
          waitingFor.on('value', (ss)=>{
            console.log("got value change");
            let data = ss.val();
            if (!data){
              return null;
            } else {
              that.sessionArrived();
              waitingFor.off();
            }
          });
        });

        // console.log("called");
        // let adminRef = firebase.database().ref().child("Admin");
        // let newadminRef = adminRef.push();
        // console.log(newadminRef);
        // let admin = {
        //   "name": "jorss"
        // };
        // console.log(admin);
        // newadminRef.set(admin);
    }

    demoSession() {
        console.log("AdminHome networkSession");
        let proceed = true;
        if (!!that.state.locked){
          let response = prompt("locked code?");
          //alert(response);
          if (response == secretphrase){
            proceed = true;
          } else {
            proceed = false;
          }
        }
        if (!proceed){
          return;
        }
        //TODO: change these for a network session
        //Select one DB at random here...
        //let db_index = 2;//[0,1,3][Math.floor(Math.random()*3)];
        let db_index = [0,1,2,3][Math.floor(Math.random()*4)];

        const sessionRef = this.props.dbs[db_index].database().ref().child(this.props.institution).child("Sessions");
        const newSessionRef = sessionRef.push();
        const timeCreated = new Date().toString();
        const timestamp = new Date().getTime();

        const minMinutes = 9 * 60;              // 09:00 = 540
        const maxMinutes = 15 * 60 + 30;        // 15:30 = 930 minutes
        const NUM_QUIP_EVENTS = 3;
        const NUM_QUIPS = 5

        // Generate N random minutes within bounds
        const randomMinutes = Array.from({ length: NUM_QUIP_EVENTS }, () =>
          Math.floor(Math.random() * (maxMinutes - minMinutes + 1) + minMinutes)
        ).sort((a, b) => a - b); // sort ascending

        const pool = [0, 1, 2, 3, 4, 5];
        const randomValues = pool
          .sort(() => Math.random() - 0.5) // shuffle
          .slice(0, NUM_QUIPS);

        // Pair minutes with unique values
        const events = randomMinutes.map((mins, i) => ({
          minutes: mins,
          value: randomValues[i]
        }));

        console.log("monkey", events);


          
        let isSlow = confirm("Would you like this to be a slow session?");
        let msPerSec = 25;
        if (!!isSlow){
          msPerSec = 50;
        }
        const session = {
            //"Title": this.props.user.displayName + timeCreated,
            "UserCount": 0,
            "GameParams": {
                "StartPrice": "2100", //(this.state.StartPrice*100).toFixed(0),
                "msPerSec": msPerSec,
                "numLiq": 150,
                "numInf": 150,
                "numMom": 75,
                "numPStar": 3,
                "FracOfDay": 1
            },
            "StartSim": {
                "SessionID": newSessionRef.key
            },
            "Info": {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false,
                "Demo": true,
                "AuctionMode": 0,
                "Timestamp": timestamp,
                "QuipEvents": events
            }
        };
        newSessionRef.set(session).then(()=>{
          this.setState({
            isWaiting: true,
            waitingForId: newSessionRef.key
          });
          let that = this;
          console.log("waiting for", newSessionRef.key);
          const waitingFor = this.props.dbs[db_index].database().ref().child(this.props.institution).child("PlayableSessions").child(newSessionRef.key);
          waitingFor.on('value', (ss)=>{
            console.log("got value change");
            let data = ss.val();
            if (!data){
              return null;
            } else {
              that.sessionArrived();
              waitingFor.off();
              introJs().setOptions({
                steps: this.state.steps,
                  tooltipClass: 'custom-tooltip',
                  overlayOpacity: 0.6
              }).start();
            }
          });
        });
        /*newSessionRef.child("Info").set(
            {
                "Title": this.props.user.displayName + " " + timeCreated,
                "Creator": this.props.user.uid,
                "Solo": false
            })*/
        // console.log("called");
        // let adminRef = this.props.dbs[0].database().ref().child("Admin");
        // let newadminRef = adminRef.push();
        // console.log(newadminRef);
        // let admin = {
        //   "name": "jorss"
        // };
        // console.log(admin);
        // newadminRef.set(admin);
    }


    componentWillMount() {
        //  console.log("AdminHome componentDidMount");
        if (includelocks){
          this.lockRef = this.props.dbs[0].database().ref().child(this.props.institution).child("lockmode");
          this.lockRef.on("value", (snap)=>{
            let lockedVal = snap.val();
            this.setState({locked: !!lockedVal});
          });
        } else {
          this.setState({locked: false});
        }
    }

    startIntro() {
        //console.log("AdminHome startIntro");
        this.setState({
            stepsEnabled: true
        })
    }

    render() {
        // console.log("AdminHome render");

        const {stepsEnabled, steps, initialStep} = this.state;
        let isDemo = false;
        return (
            <div>
                <div className="admin-menu">
                    {!isDemo &&
                    <Link to="/Home">
                        <button className="button-default" disabled={this.state.isWaiting} onClick={this.demoSession}>
                            Network Session
                        </button>
                    </Link>
                    }
                    <Link to="/Home">
                        <button className="button-default" disabled={this.state.isWaiting} onClick={this.soloSession}>
                            Solitaire Session
                        </button>
                    </Link>
                    {/* <Link to="/Home">
                        <button className="button-default" disabled={this.state.isWaiting} onClick={this.demoSession}>
                            Demo Session
                        </button>
                    </Link> */}
                    {includelocks &&
                      <Link to="/Home">
                          <button onClick={this.toggleLock}>
                              {this.state.locked ? 'Unlock Session Creation' : 'Lock Session Creation'}
                          </button>
                      </Link>
                    }
                </div>
                <AdminSessionContainer
                    user={this.props.user}
                    institution={this.props.institution}
                    dbs={this.props.dbs}
                />
                <div className="versionNumber">v0.9.9</div>
            </div>
        );
    }
}

AdminHome.propTypes = {
    user: PropTypes.object,
    authed: PropTypes.bool
};

export default AdminHome;



// WEBPACK FOOTER //
// ./src/components/Dashboard/MainDashboard.js